import React from 'react';
import {useTranslation} from 'react-i18next';
import {Vendor} from 'pwm-shared/src/types';
import {IVendorDbaEntity} from 'pwm-shared/src/types/Vendor';
import {PWMCard, PWMCardHeader, PWMCardContent} from 'src/PWM/components/PWMCard';
import {IconButton, Tooltip} from '@mui/material';
import {tokens} from 'src/PWM/locales/tokens';
import {PWMCheckedIcon, PWMEditIcon} from 'src/PWM/components/PWMIcons';
import {BodyText} from 'src/PWM/components/PWMTypography';
import {PWMPropertyList, PWMPropertyListItem} from 'src/PWM/components/PWMPropertyList';
import {formatDate} from 'src/PWM/utils/date-utils';
import EditVendorDbaModal from './EditVendorDbaModal';
import {useVendorApi} from '../vendor.api';
const EditDbaNames: React.FC<IEditDbaNamesProps> = (props) => {
  const {vendorInfo} = props;

  const {t} = useTranslation();
  const vendorApi = useVendorApi();

  const currentDBANames: IVendorDbaEntity[] = React.useMemo(() => {
    return vendorInfo?.dbaName?.filter(({
            isActive,
            deleted
          }: IVendorDbaEntity) => (isActive && !Boolean(deleted))) || [];
  }, [vendorInfo.dbaName]);

  const previousDBANames: IVendorDbaEntity[] = React.useMemo(() => {
    return vendorInfo?.dbaName?.filter(({
            isActive,
            deleted
          }: IVendorDbaEntity) => (!isActive || Boolean(deleted))) || [];
  }, [vendorInfo.dbaName]);

  const [editModalOpen, setEditModalOpen] = React.useState<boolean>(false);

  const openModal = () => {
    setEditModalOpen(true);
  };
  const closeEditModal = () => {
    setEditModalOpen(false);
  }

  const updateDbaName = async (dbaNames: IVendorDbaEntity[]) => {
    if (!dbaNames.length || !vendorApi) return;
    vendorInfo.dbaName = dbaNames;

    // @ts-ignore type error todo fix types
    await vendorApi.updateVendor(vendorInfo);
    closeEditModal();
    if (props.onSave) return props.onSave(vendorInfo.dbaName);
  }

  return (
    <>
      <PWMCard>
        <PWMCardHeader
          title={`${t(tokens.interface.dbanames)}`}
          action={<IconButton onClick={openModal}><PWMEditIcon /></IconButton>}
        />
        <PWMCardContent>
          {currentDBANames.length > 0 && (
            <>
              <BodyText>Current</BodyText>
              <PWMPropertyList>
                {currentDBANames.map(({id, name, isPreferredName}) => (
                  <PWMPropertyListItem
                    key={`${id}-${name}`}
                    label=""
                  >
                    {isPreferredName &&
                      <Tooltip title={`${t(tokens.interface.dbanamestitle)}`}>
                        <PWMCheckedIcon htmlColor="green" />
                      </Tooltip>} {name}
                  </PWMPropertyListItem>
                ))}
              </PWMPropertyList>
            </>
          )}
          {previousDBANames.length > 0 && (
            <>
              <BodyText>Previous</BodyText>
              <ul>
                {previousDBANames.map(({id, name, deleted}) => (
                  <li key={`${id}-${name}`}>
                    {name} {formatDate(deleted)}
                  </li>
                ))}
              </ul>
            </>
          )}
        </PWMCardContent>
      </PWMCard>
      <EditVendorDbaModal
        isOpen={editModalOpen}
        onSave={updateDbaName}
        onClose={closeEditModal}
        isSaving={false}
        dbaNames={vendorInfo.dbaName}
      />
    </>
  );
};

export default EditDbaNames;

interface IEditDbaNamesProps {
  children?: React.ReactNode;
  vendorInfo: Vendor.UpdateVendorInfo;
  onSave?(dbaName: IVendorDbaEntity[]): Promise<void>;
}